<mat-menu
  #bulkActionMenu="matMenu"
  [overlapTrigger]="false"
  xPosition="before"
  yPosition="above"
  class="mat-menu-panel bulk-menu"
>
  @if (bulkActionsNote) {
    <div class="px-4 pb-1 pt-2 text-xs text-grey-midGrey">
      {{ bulkActionsNote }}
    </div>
  }
  @for (action of bulkActions; track action.label) {
    @if (selection$ | async; as selection) {
      @if (!checkHide(action, selection.selected)) {
        <mat-menu
          #bulkSubActionMenu="matMenu"
          [overlapTrigger]="false"
          class="mat-menu-panel bulk-menu"
        >
          @for (subAction of action.subActions ?? []; track subAction.label) {
            <div class="px-4 text-sm font-medium">
              <button
                (click)="executeSubAction(subAction, selection.selected)"
                class="font-medium"
                mat-menu-item
              >
                <mat-icon class="material-icons-outlined pr-4">{{
                  subAction.icon
                }}</mat-icon>
                @if (subAction.translate) {
                  {{ subAction.label | transloco }}
                } @else {
                  {{ subAction.label }}
                }
              </button>
            </div>
          }
        </mat-menu>
        @if (action.separatorAbove) {
          <div
            role="separator"
            class="my-1 border-t border-grey-lightGrey"
          ></div>
        }
        <div class="px-4 text-sm font-medium">
          <button
            (click)="executeAction(action, selection.selected)"
            class="font-medium"
            mat-menu-item
            [matMenuTriggerFor]="
              action.subActions?.length ? bulkSubActionMenu : null
            "
            [disabled]="checkDisabled(action, selection.selected)"
            [matTooltip]="
              getTooltipLabel(action, selection.selected) | transloco
            "
            matTooltipPosition="above"
            matTooltipClass="tooltip-above"
          >
            <mat-icon class="material-icons-outlined pr-4">{{
              action.icon
            }}</mat-icon>
            @if (action.translate) {
              {{ getLabel(action, selection.selected) | transloco }}
            } @else {
              <!-- If the action is not translated, we assume it is already in the correct language -->
              {{ getLabel(action, selection.selected) }}
            }
          </button>
        </div>
      }
    }
  }
</mat-menu>

<mat-menu
  #filterActionMenu="matMenu"
  [overlapTrigger]="false"
  xPosition="before"
  yPosition="above"
  class="mat-menu-panel bulk-menu"
>
  @if (filterCategories) {
    <app-sep-filter
      [categories]="filterCategories"
      [applyButtonText]="'general.apply' | transloco"
      (filtersChanged)="applyFilter($event)"
    ></app-sep-filter>
  }
</mat-menu>

<mat-menu
  #rowActionMenu="matMenu"
  [overlapTrigger]="false"
  yPosition="above"
  xPosition="after"
  class="mat-menu-panel bulk-menu"
>
  @for (action of rowActions; track action.label) {
    @if (targetedRow && !checkHide(action, targetedRow)) {
      <mat-menu
        #rowSubActionMenu="matMenu"
        [overlapTrigger]="false"
        class="mat-menu-panel bulk-menu"
      >
        @for (subAction of action.subActions ?? []; track subAction.label) {
          <div class="px-6 text-xs">
            <button
              (click)="executeSubAction(subAction, targetedRow)"
              class="font-medium"
              mat-menu-item
            >
              <mat-icon class="material-icons-outlined pr-4">
                {{ subAction.icon }}
              </mat-icon>
              @if (subAction.translate) {
                {{ subAction.label | transloco }}
              } @else {
                {{ subAction.label }}
              }
            </button>
          </div>
        }
      </mat-menu>
      @if (action.separatorAbove) {
        <div role="separator" class="my-1 border-t border-grey-lightGrey"></div>
      }
      <div class="px-6 text-xs">
        <button
          (click)="executeAction(action, targetedRow)"
          class="font-medium"
          mat-menu-item
          [matMenuTriggerFor]="
            action.subActions?.length ? rowSubActionMenu : null
          "
          [disabled]="checkDisabled(action, targetedRow)"
          [matTooltip]="getTooltipLabel(action, targetedRow) | transloco"
          matTooltipPosition="above"
          matTooltipClass="tooltip-above"
        >
          <mat-icon class="material-icons-outlined pr-4">
            {{ action.icon }}
          </mat-icon>
          @if (action.translate) {
            {{ getLabel(action, targetedRow) | transloco }}
          } @else {
            <!-- If the action is not translated, we assume it is already in the correct language -->
            {{ getLabel(action, targetedRow) }}
          }
        </button>
      </div>
    }
  }
</mat-menu>

<mat-menu
  #toolbarExportActionMenu="matMenu"
  [overlapTrigger]="false"
  xPosition="before"
  class="mat-menu-panel bulk-menu"
>
  @for (action of visibleToolbarExportActions; track action.label) {
    <mat-menu
      #toolbarExportSubActionMenu="matMenu"
      [overlapTrigger]="false"
      class="mat-menu-panel bulk-menu"
    >
      @for (subAction of action.subActions ?? []; track subAction.label) {
        <div class="px-4 text-sm font-medium">
          <button
            (click)="executeSubAction(subAction, undefined)"
            class="font-medium"
            mat-menu-item
          >
            <mat-icon class="material-icons-outlined pr-4">{{
              subAction.icon
            }}</mat-icon>
            @if (subAction.translate) {
              {{ subAction.label | transloco }}
            } @else {
              {{ subAction.label }}
            }
          </button>
        </div>
      }
    </mat-menu>
    @if (action.separatorAbove) {
      <div role="separator" class="my-1 border-t border-grey-lightGrey"></div>
    }
    <div class="px-4 text-sm font-medium">
      <button
        (click)="executeAction(action, undefined)"
        class="font-medium"
        mat-menu-item
        [matMenuTriggerFor]="
          action.subActions?.length ? toolbarExportSubActionMenu : null
        "
        [disabled]="checkDisabled(action, undefined)"
        [matTooltip]="getTooltipLabel(action, undefined) | transloco"
        matTooltipPosition="above"
        matTooltipClass="tooltip-above"
      >
        <mat-icon class="material-icons-outlined pr-4">{{
          action.icon
        }}</mat-icon>
        @if (action.translate) {
          {{ getLabel(action, undefined) | transloco }}
        } @else {
          {{ getLabel(action, undefined) }}
        }
      </button>
    </div>
  }
</mat-menu>

<div class="overflow-x-auto rounded-xl border border-grey-lightGrey shadow-sm">
  <ng-content select="[top]" />
  <div class="flex w-full items-center justify-between gap-4 p-4">
    @if (showSearch) {
      <div class="flex grow items-center gap-2">
        <app-input-field
          class="w-full"
          [control]="searchControl"
          [placeholder]="searchPlaceholder | transloco"
          [bottomMargin]="false"
        ></app-input-field>
      </div>
      @if (primaryButtonTitle && !hidePrimaryButton) {
        <div class="flex shrink-0 justify-end gap-2">
          <span
            class="hidden h-11 w-full sm:flex"
            [matTooltip]="
              primaryButtonDisabled ? primaryButtonDisabledTooltip : ''
            "
            matTooltipPosition="above"
            matTooltipClass="tooltip-above"
          >
            <app-primary-button
              class="flex w-full items-center justify-center"
              icon="add"
              [text]="primaryButtonTitle"
              [disabled]="primaryButtonDisabled"
              (buttonClicked)="primaryButtonClicked()"
            ></app-primary-button>
          </span>
          <span
            class="h-11 w-full sm:hidden"
            [matTooltip]="
              primaryButtonDisabled ? primaryButtonDisabledTooltip : ''
            "
            matTooltipPosition="above"
            matTooltipClass="tooltip-above"
          >
            <button
              class="flex h-11 w-full items-center justify-center rounded-lg border border-blue bg-blue"
              [disabled]="primaryButtonDisabled"
              [ngClass]="{
                'cursor-not-allowed opacity-60': primaryButtonDisabled,
              }"
              (click)="primaryButtonClicked()"
              title="{{ primaryButtonTitle }}"
            >
              <mat-icon class="material-icons-outlined text-white"
                >add</mat-icon
              >
            </button>
          </span>
        </div>
      }
    }

    @if (!showSearch) {
      <div class="flex w-full items-center justify-between">
        @if (name) {
          <h1 class="text-xl font-medium">{{ name }}</h1>
        }
        <div class="flex items-center justify-end space-x-2">
          @if (toolbarLeftTemplate) {
            <ng-container
              [ngTemplateOutlet]="toolbarLeftTemplate"
            ></ng-container>
          }
          @if (hasBulkActionButton && (selection$ | async)?.selected?.length) {
            <button
              class="ml-2 flex items-center justify-center rounded-lg border border-grey-lightGrey p-2"
              [matMenuTriggerFor]="bulkActionMenu"
              [matTooltip]="'general.table.applyToSelectedUsers' | transloco"
              matTooltipPosition="above"
              matTooltipClass="tooltip-above"
            >
              <mat-icon class="material-icons-outlined">more_vert</mat-icon>
            </button>
          }
          @if (filterCategories && sepTableService.dataSource.length > 0) {
            <button
              class="ml-2 flex items-center justify-center rounded-lg border border-grey-lightGrey p-2"
              [ngClass]="{
                'shadow-sm outline-none ring-2 ring-blue ring-opacity-50':
                  (sepTableService.isFiltered$ | async),
              }"
              [matMenuTriggerFor]="filterActionMenu"
              [matTooltip]="'general.table.filter' | transloco"
              matTooltipPosition="above"
              matTooltipClass="tooltip-above"
            >
              <mat-icon
                class="material-icons-outlined"
                [ngClass]="{
                  'text-blue': (sepTableService.isFiltered$ | async),
                }"
                >filter_alt</mat-icon
              >
            </button>
          }
          @if (allowExport) {
            @if (visibleToolbarExportActions.length) {
              <button
                class="ml-2 flex items-center justify-center gap-1 rounded-lg border border-grey-lightGrey px-3 py-2 text-sm font-medium"
                [matMenuTriggerFor]="toolbarExportActionMenu"
              >
                <mat-icon class="material-icons-outlined">download</mat-icon>
                <span>{{ 'general.export' | transloco }}</span>
              </button>
            } @else {
              <button
                class="ml-2 flex items-center justify-center rounded-lg border border-grey-lightGrey p-2"
                (click)="exportContentButtonClicked()"
              >
                <mat-icon class="material-icons-outlined">download</mat-icon>
              </button>
            }
          }
          @if (primaryButtonTitle && !hidePrimaryButton && !showSearch) {
            <span
              class="hidden md:flex"
              [matTooltip]="
                primaryButtonDisabled ? primaryButtonDisabledTooltip : ''
              "
              matTooltipPosition="above"
              matTooltipClass="tooltip-above"
            >
              <app-primary-button
                icon="add"
                [text]="primaryButtonTitle"
                [disabled]="primaryButtonDisabled"
                (buttonClicked)="primaryButtonClicked()"
              ></app-primary-button>
            </span>
            <span
              class="md:hidden"
              [matTooltip]="
                primaryButtonDisabled ? primaryButtonDisabledTooltip : ''
              "
              matTooltipPosition="above"
              matTooltipClass="tooltip-above"
            >
              <button
                class="flex items-center justify-center rounded-lg border border-blue bg-blue p-2"
                [disabled]="primaryButtonDisabled"
                [ngClass]="{
                  'cursor-not-allowed opacity-60': primaryButtonDisabled,
                }"
                (click)="primaryButtonClicked()"
                title="{{ primaryButtonTitle }}"
              >
                <mat-icon class="material-icons-outlined text-white"
                  >add</mat-icon
                >
              </button>
            </span>
          }
        </div>
      </div>
    }
  </div>

  <div class="relative">
    <table mat-table [dataSource]="sepTableService.dataView" class="w-full">
      <!-- Column Definition -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          @if (hasCheckbox) {
            <div class="flex items-center gap-2">
              <mat-checkbox
                class="text-xs"
                (change)="toggleAllRows()"
                [checked]="
                  sepTableService.dataSource.length > 0 &&
                  (selection$ | async)?.selected?.length ===
                    sepTableService.dataView.length
                "
              >
              </mat-checkbox>
              <span class="min-w-20 text-xs">
                @if (
                  checkboxSelectedText && (selection$ | async)?.selected?.length
                ) {
                  {{
                    (selection$ | async)?.selected?.length +
                      ' ' +
                      checkboxSelectedText
                  }}
                }
              </span>
            </div>
          }
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            class="text-xs"
            (click)="$event.stopPropagation()"
            (change)="selectRow(row)"
            [checked]="(selection$ | async)?.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Column Definition -->
      @for (column of columns; track column.headerName) {
        <ng-container matColumnDef="{{ column.headerName }}">
          <th
            class="cursor-pointer"
            mat-header-cell
            *matHeaderCellDef
            [ngClass]="{ 'text-xs text-transparent': hideColumnHeader }"
            (click)="sortColumn(column.key)"
          >
            <span class="flex min-w-0 items-center gap-1 whitespace-nowrap">
              <div class="flex shrink-0 items-center gap-1">
                @if (column.headerRenderComponent) {
                  <ng-container
                    [ngTemplateOutlet]="column.headerRenderComponent"
                    [ngTemplateOutletContext]="{ $implicit: '' }"
                  ></ng-container>
                } @else {
                  {{ column.headerName | transloco }}
                }
              </div>
              <mat-icon class="hvs-icon shrink-0 p-1 text-xs"
                >swap_vert</mat-icon
              >
            </span>
          </th>
          <td mat-cell *matCellDef="let element">
            @if (column.field) {
              @if (column.translate) {
                {{ element[column.field] | transloco }}
              } @else {
                {{ element[column.field] }}
              }
            } @else if (column.renderComponent) {
              <ng-container
                [ngTemplateOutlet]="column.renderComponent"
                [ngTemplateOutletContext]="{ $implicit: element }"
              ></ng-container>
            }
          </td>
        </ng-container>
      }

      <!-- Column Definition -->
      <ng-container matColumnDef="rowActions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button
            class="ml-2 min-w-0"
            [matMenuTriggerFor]="rowActionMenu"
            (click)="setTargetedRow(row)"
          >
            <mat-icon
              class="material-icons-outlined cursor-pointer text-base text-grey"
              >more_vert</mat-icon
            >
          </button>
        </td>
      </ng-container>

      <!-- Table Header Definition -->
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        [ngStyle]="{
          height: hideColumnHeader ? '15px' : '',
          'background-color': '#f7f8f9',
        }"
      ></tr>
      <!-- Table Row Definition -->
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- No Data Row Definition -->
      <tr class="mat-mdc-row mdc-data-table__row" *matNoDataRow>
        <td
          class="mat-mdc-cell mdc-data-table__cell h-20 text-center"
          colspan="1000"
          style="text-align: center"
        >
          @if (loading) {
            <div class="flex h-8 justify-center">
              <app-loading></app-loading>
            </div>
          } @else {
            {{ noDataText }}
          }
        </td>
      </tr>
    </table>
  </div>
</div>
